export interface RepairerSearch {
  readonly page: number;
  readonly q?: string;
  readonly chain?: string;
}

export function parseRepairerSearch(
  raw: Record<string, unknown>,
): RepairerSearch {
  const page = Number(raw.page);
  // Router decodes numeric/boolean-looking search terms on a fresh URL load.
  const q =
    typeof raw.q === "number" || typeof raw.q === "boolean"
      ? String(raw.q)
      : raw.q;
  const chain =
    typeof raw.chain === "number" || typeof raw.chain === "boolean"
      ? String(raw.chain)
      : raw.chain;
  return {
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
    q: typeof q === "string" ? q.trim() || undefined : undefined,
    chain: typeof chain === "string" ? chain.trim() || undefined : undefined,
  };
}
